module.exports = __webpack_public_path__ + "static/media/base_map.4867ac8a.png";